var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4c83f7;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Send_Button",
    "data-name": "Send Button",
    transform: "translate(-0.455)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    className: "cls-1",
    width: 46,
    height: 46,
    rx: 23,
    transform: "translate(0.455)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon.send",
    transform: "translate(20.316 11.309) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    className: "cls-2",
    x1: 8.843,
    y2: 8.843,
    transform: "translate(9.157)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    className: "cls-2",
    d: "M18,0,14.293,18,9.157,8.843,0,3.707Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.a2d7958888709d66f636243360312bb6.svg";
export { ForwardRef as ReactComponent };